import type { IconifyIcon } from '@iconify/types'

export default {
  body: '<path fill="currentColor" d="M16.707 4.707L11.414 10l5.293 5.293l-1.414 1.414L10 11.414l-5.293 5.293l-1.414-1.414L8.586 10L3.293 4.707l1.414-1.414L10 8.586l5.293-5.293z"/>',
  width: 20,
  height: 20
} satisfies IconifyIcon
